import router from './router'
import store from './store'
import { getToken } from '@/utils/auth' // get token from cookie

const localToken = getToken()
if (localToken) {
  store.dispatch('initToken', localToken)
}

const whiteList = ['/live', '/error', '/cover', '/Q'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  let member_type = undefined
  if ('meta' in to && 'title' in to.meta) {
    document.title = to.meta.title
  }
  if ('meta' in to && 'member_type' in to.meta) {
    member_type = to.meta.member_type
  }
  if (member_type) {
    if (!member_type.length) {
      member_type = [member_type]
    }
    if (member_type.includes(1)) {
      member_type.push(101);
    }
  }

  let state = ''
  if ('state' in to.query) {
    state = to.query.state
  }

  const relogin = () => {
    setTimeout(() => {
      const appid = window.__config__.appid
      const service_url = encodeURI(window.__config__.server_url + 'auth/wechat_auth')
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${service_url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
      location.href = url
    }, 10);
  }

  const userRoute = (user) => {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if (!user) {
        next('/error')
      } else if (user.member_type === 0) {
        if (to.path == '/login') {
          next()
        } else {
          next(`/login?state=${state}`)
        }
      } else {
        if (!member_type) {
          next()
        } else if (member_type.includes(user.member_type) || user.member_type == member_type) {
          next()
        } else {
          next('/error')
        }
      }
      // next(`/login?state=${state}&redirect=${to.fullPath}`)
    }

    
  }

  let currentToken = store.state.token

  if (to.path == '/sync' || to.path == '/cover' || to.path == '/c-event' || to.path == '/live-q') {
    next()
  } else {
    if (currentToken) {
      let currentUser = store.state.user
      if (!currentUser) {
        try {
          currentUser = await store.dispatch('syncUser')
          console.log('user', currentUser)
        } catch (error) {
          console.log(error)
          await store.dispatch('resetToken')
          return relogin()
        }
      }
      userRoute(currentUser)
    } else {
      relogin()
    }
  }
})